import { render, staticRenderFns } from "./ManageAssetImageComponent.vue?vue&type=template&id=10815526&"
import script from "./ManageAssetImageComponent.vue?vue&type=script&lang=js&"
export * from "./ManageAssetImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports